import type { IconProps } from "@tabler/icons-react"

type AutoFillIconProps = Pick<IconProps, "className" | "size">

export const AutoFillIcon: React.FC<AutoFillIconProps> = ({
  className = "text-grey1",
  size = 23,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.262 7.05085C12.881 6.6699 12.3096 6.6699 11.9286 7.05085L0.785715 18.1937C0.404762 18.5747 0.404762 19.1461 0.785715 19.5271L2.9762 21.7175C3.35715 22.0985 3.92858 22.0985 4.30953 21.7175L15.4524 10.5747C15.8334 10.1937 15.8334 9.62229 15.4524 9.24133L13.262 7.05085ZM12.2143 12.289L10.2143 10.289L12.5001 8.00323L14.5001 10.0032L12.2143 12.289Z"
      fill="currentColor"
    />
    <path
      d="M7.84115 6.21301L7.26929 8.24055L6.69744 6.21299L4.66989 5.64115L6.69742 5.06928L7.26929 3.04175L7.84115 5.06928L9.86869 5.64115L7.84115 6.21301Z"
      fill="currentColor"
    />
    <path
      d="M20.176 14.6785L19.3794 17.5029L18.5828 14.6785L15.7583 13.8818L18.5828 13.0852L19.3794 10.2607L20.176 13.0852L23.0005 13.8818L20.176 14.6785Z"
      fill="currentColor"
    />
    <path
      d="M17.0093 3.71018L16.3408 6.08039L15.6723 3.71016L13.3021 3.04166L15.6723 2.37314L16.3408 0.00292969L17.0093 2.37314L19.3796 3.04166L17.0093 3.71018Z"
      fill="currentColor"
    />
  </svg>
)
